import React from 'react';
import { Layout } from '../components/Layout';
import { SEO } from '../components/SEO';
export function PrivacyPolicyPage() {
  return <Layout data-id="element-1635">
      <SEO title="Politique de Confidentialité | ADCC" description="L'Association Dignité Compétence Création (ADCC) accorde une grande importance à la protection de vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre site web adcc.africa." url="https://adcc.africa/privacy-policy" data-id="element-1636" />
      <div className="bg-[#2C3E50] text-white py-16" data-id="element-1637">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1638">
          <h1 className="text-4xl font-bold mb-4" data-id="element-1639">
            Politique de Confidentialité
          </h1>
          <p className="text-gray-300" data-id="element-1640">
            Dernière mise à jour : 10 Janvier 2026
          </p>
        </div>
      </div>

      <section className="py-20 bg-white" data-id="element-1641">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1642">
          <div className="prose prose-lg text-gray-600 max-w-none" data-id="element-1643">
            <p className="mb-8 leading-relaxed" data-id="element-1644">
              L'Association Dignité Compétence Création (ADCC) accorde une
              grande importance à la protection de vos données personnelles.
              Cette politique de confidentialité explique comment nous
              collectons, utilisons et protégeons vos informations lorsque vous
              utilisez notre site web adcc.africa.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-4" data-id="element-1645">
              1. Données collectées
            </h2>
            <p data-id="element-1646">
              Nous collectons les informations que vous nous fournissez
              volontairement via nos formulaires :
            </p>
            <ul className="list-disc pl-6 mb-8 space-y-2" data-id="element-1647">
              {["Informations d'identité (nom, prénom)", 'Coordonnées (email, numéro de téléphone, ville/quartier)', "Informations professionnelles (CV, expérience, domaine d'expertise)", "Informations de paiement (lors d'un don, traitées de manière sécurisée par nos prestataires Stripe/PayPal)"].map((item, idx) => <li key={idx} data-id="element-1648">{item}</li>)}
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-4" data-id="element-1649">
              2. Utilisation des données
            </h2>
            <p data-id="element-1650">Vos données sont utilisées exclusivement pour :</p>
            <ul className="list-disc pl-6 mb-8 space-y-2" data-id="element-1651">
              {['Traiter vos demandes (bénévolat, partenariat, recrutement, formation)', 'Gérer vos dons et émettre les reçus fiscaux', 'Vous envoyer notre newsletter (si vous y avez souscrit)', 'Améliorer nos services et notre communication'].map((item, idx) => <li key={idx} data-id="element-1652">{item}</li>)}
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-4" data-id="element-1653">
              3. Protection et partage des données
            </h2>
            <p data-id="element-1654">
              Vos données personnelles sont strictement confidentielles. Elles
              ne sont jamais vendues ou louées à des tiers. Elles peuvent être
              partagées uniquement avec :
            </p>
            <ul className="list-disc pl-6 mb-8 space-y-2" data-id="element-1655">
              {["Les membres habilités de l'équipe ADCC pour le traitement de votre dossier", 'Nos prestataires techniques (hébergement, paiement) soumis à des obligations de confidentialité', "Des employeurs partenaires (uniquement avec votre accord explicite dans le cadre d'un recrutement)"].map((item, idx) => <li key={idx} data-id="element-1656">{item}</li>)}
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-12 mb-4" data-id="element-1657">
              4. Vos droits
            </h2>
            <p data-id="element-1658">
              Conformément à la législation en vigueur, vous disposez d'un droit
              d'accès, de rectification, de suppression et d'opposition
              concernant vos données personnelles. Pour exercer ces droits,
              contactez-nous à :{' '}
              <a href="mailto:contact@adcc.africa" className="text-[#1E88E5] hover:underline" data-id="element-1659">
                contact@adcc.africa
              </a>
            </p>
          </div>
        </div>
      </section>
    </Layout>;
}